import { useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import TimesheetNavBar from "./TimesheetNavBar";
import { FetchActiveUsers, User, UserSelect } from "./UserSelect";
import { SelectInstance } from "react-select";

const AddTime = () => {
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
	}

	interface Location {
		active: boolean
		id: number
		long_name: string
		short_name: string
	}

	
	interface Option {
		value: any;
		label: string;
	}

	const handleSelectChange = async () => {
		if (unitRef && unitRef.current) {
			const id = unitRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/unit?id=" + id);
			const unit = await response.json()
			setSelectedUnit(unit)
			setIsVisible(true)
			setMsg("")
		}
	}

	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		if (response) {
			const units = await response.json()
			setUnits(units)
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}

	var userRef = useRef<HTMLSelectElement>(null)
	var currentDate = new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString()
	var unitRef = useRef<HTMLSelectElement>(null)
	var locationRef = useRef<HTMLSelectElement>(null)
	var timeInRef = useRef<HTMLInputElement>(null);
	var timeOutRef = useRef<HTMLInputElement>(null);
	var dateRef = useRef<HTMLInputElement>(null);
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const [msg, setMsg] = useState("")
	const [isVisible, setIsVisible] = useState(false)
	const [selectedUnit, setSelectedUnit] = useState<Unit>({ id: 0, unit: "", active: false })
	const [unitName, setUnitName] = useState("")
	const [units, setUnits] = useState<Unit[]>([])
	const [locations, setLocations] = useState<Location[]>([])
	const [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })


	useEffect(() => {
		FetchActiveUsers(setUsers)
		getUnits()
		getLocations()
		setMsg("")
	}, [setUsers, setMsg])

	const addTime = async () => {
		var userID: string = ""
		if (userRef && userRef.current) {
			userID = userRef.current.value
		}
		var unitID: string = ""
		if (unitRef && unitRef.current) {
			unitID = unitRef.current.value
		}
		var locationID: string = ""
		if (locationRef && locationRef.current) {
			locationID = locationRef.current.value
		}
		var date: string = ""
		if (dateRef && dateRef.current) {
			date = dateRef.current.value
		}
		var clockIn: string = ""
		if (timeInRef && timeInRef.current) {
			clockIn = timeInRef.current.value
		}
		var clockOut: string = ""
		if (timeOutRef && timeOutRef.current) {
			clockOut = timeOutRef.current.value
		}


		if (clockIn > clockOut) {
			setMsg("Clock in time cannot be after clock out time")
			return
		}

		if (userID === "" || unitID === "" || locationID === "" || date === "" || clockIn === "" || clockOut === "") {
			setMsg("Please fill out all fields")
			return
		}

		var entered_by = localStorage.getItem("userID") || ""
		const payload = {"user": userID, "unit": unitID, "date": date, "clock_in": clockIn, "clock_out": clockOut, "location": locationID, entry_method: "manual_entry", entered_by: entered_by }
		const response = await fetch(process.env.REACT_APP_API+"/api/addTime", {
			method: "POST",
			body: JSON.stringify(payload)
		})

		if (response.status === 200) {
			setMsg("Time submitted")
		} else {
			setMsg("Error submitting time")
			return
		}

		// clear current values
		if (userRef && userRef.current) {
			userRef.current.value = ""
		}
		if (unitRef && unitRef.current) {
			unitRef.current.value=""
		}
		if (locationRef && locationRef.current) {
			locationRef.current.value = ""
		}
		if (dateRef && dateRef.current) {
			dateRef.current.value = currentDate.substring(0, 10)
		}
		if (timeInRef && timeInRef.current) {
			timeInRef.current.value=""
		}
		if (timeOutRef && timeOutRef.current) {
			timeOutRef.current.value=""
		}
		if (selectRef && selectRef.current) {
			selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
		}
	}

	return (
		<div className="resilire">
			<AdminNavBar />
			<TimesheetNavBar />
			<h3>Add Timesheet</h3>
			<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={userRef} onChange={setMsg} selectRef={selectRef} />
			<label htmlFor="unit">Unit</label>
			<select id="units" onChange={handleSelectChange} ref={unitRef}>
				<option value=""></option>
				{units.map((unit) => (
					<option value={unit.id} key={unit.id}>{unit.unit}</option>
				))}
			</select>

			<label htmlFor="locations">Location</label>
			<select id="location" onChange={handleSelectChange} ref={locationRef}>
				<option value=""></option>
				{locations.map((location) => (
					<option value={location.id} key={location.id}>{location.short_name} - {location.long_name}</option>
				))}
			</select>
			<label htmlFor="currentDate">Date</label>
			<input type="date" id="current_date" name="current_date" defaultValue={currentDate.substring(0, 10)} ref={dateRef} />
			<label htmlFor="clock_in_time">Clock-in Time</label>
			<input type="time" id="clock_in_time" name="clock_in_time" ref={timeInRef} />
			<label htmlFor="clock_out_time">Clock-out Time</label>
			<input type="time" id="clock_out_time" name="clock_out_time" ref={timeOutRef} />
			<button onClick={addTime}>Submit</button>

			{msg && (
				<div style={{ color: 'red' }}>
					{msg}
				</div>
			)}
		</div>
	)
};
export default AddTime;
